document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("discount-popup");
  const POPUP_KEY = "popupClosed";
  const getDiscountBtn = document.querySelector('.get-discount');
  const emailInput = document.getElementById('email-popup');
  const healthCategories = document.getElementById('health-categories');
  const offerContent = document.getElementById('offer-content');
  const discountContent = document.getElementById('discount-content');
  const scriptURL = 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE'; // Define your script URL

  // Check if the popup was previously closed
  if (localStorage.getItem(POPUP_KEY) === "true") {
    popup.style.display = "none"; // Hide the popup if already closed
    return;
  }

  // Show the popup after 3 seconds
  setTimeout(() => popup.classList.remove("hidden-popup"), 3000);

  // Close the popup
  function closePopup() {
    popup.style.display = "none";
    localStorage.setItem(POPUP_KEY, "true"); // Mark popup as closed
  }

  // Event listeners for close and action buttons
  const popupClose = document.querySelector(".popup-close");
  const popupButton = document.querySelector(".popup-button");

  if (popupClose) {
    popupClose.addEventListener("click", closePopup);
  }
  if (popupButton) {
    popupButton.addEventListener("click", () => {
      closePopup();
      window.location.href = "/collections/all";
    });
  }

  // Handle Get Discount button click
  if (getDiscountBtn) {
    getDiscountBtn.addEventListener("click", () => {
      const email = emailInput.value.trim();
      const category = healthCategories.value;

      // Validate inputs
      if (!validateEmail(email)) {
        alert('Please enter a valid email address.');
        return;
      }
      if (!category) {
        alert('Please select a health category.');
        return;
      }

      // Send data to Google Apps Script
      fetch(scriptURL, {
        method: 'POST',
        body: JSON.stringify({ email, category }),
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === 'success') {
            offerContent.style.display = "none";
            document.querySelector(".f-cont").style.display = "none";
            discountContent.style.display = "block";
          } else {
            alert(data.message);
          }
        })
        .catch(error => {
          console.error('Error!', error.message);
          alert('Something went wrong. Please try again.');
        });
    });
  }

  // Copy text function with dynamic code and show message
  document.querySelectorAll('.copy-icon').forEach((icon) => {
    icon.addEventListener('click', function () {
      const code = this.getAttribute('data-code');
      const messageId = 'message' + (code === 'FREESHIP49' ? '1' : '2');
      const messageElem = document.getElementById(messageId);

      // Copy to clipboard
      navigator.clipboard.writeText(code)
        .then(() => {
          messageElem.style.display = "inline"; // Show "Copied!" message
          setTimeout(() => messageElem.style.display = "none", 2000); // Hide after 2 seconds
        })
        .catch(err => console.error('Error copying text: ', err));
    });
  });

  // Simple email validation
  function validateEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
});
